import { render, staticRenderFns } from "./processSummary.vue?vue&type=template&id=061e4387"
import script from "./processSummary.vue?vue&type=script&lang=js"
export * from "./processSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports